import { render, staticRenderFns } from "./ComponentPalette.vue?vue&type=template&id=62296681&scoped=true&"
import script from "./ComponentPalette.vue?vue&type=script&lang=js&"
export * from "./ComponentPalette.vue?vue&type=script&lang=js&"
import style0 from "./ComponentPalette.vue?vue&type=style&index=0&id=62296681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62296681",
  null
  
)

export default component.exports